import QualitySelector from '@silvermine/videojs-quality-selector';

/**
 * Video.js plugin "qualitySelector"
 *
 * The plugin is using the QualitySelector and hides sources with a different type
 *
 * @function qualitySelector
 * @param    {Object} options
 */

const pluginQualitySelector = videojs => {
  videojs.addLanguage('en', {
    'Quality selector': 'Quality',
  });
  videojs.addLanguage('de', {
    'Quality selector': 'Qualität',
  });

  QualitySelector(videojs);
  videojs.registerPlugin('qualitySelector', function (player) {
    player.ready(() => {
      // remove old button
      player.controlBar.removeChild('qualitySelector');
      // add the QualitySelector to the control bar
      player.controlBar.addChild('qualitySelector');

      // Since the plugin @silvermine/videojs-quality-selector/src/js/components/QualitySelector.js (see line 54) does
      // not use player.controlText(localize()) but plain player.controlText('') we have to localize in the same manner.
      const button = player.el_.querySelector(
        '.vjs-quality-selector .vjs-menu-button'
      );
      const buttonControlText = button.querySelector('.vjs-control-text');
      const localizedString = player.localize('Quality selector');

      button.setAttribute('title', localizedString);
      buttonControlText.textContent = localizedString;

      // get current source
      const currentSource = player.currentSource();

      // only show sources of same type
      const itemsSource = player.el_.querySelectorAll(
        '.vjs-quality-selector .vjs-menu-content li'
      );
      player.currentSources().forEach((source, i) => {
        if (itemsSource.item(i)) {
          if (source.type !== currentSource.type) {
            // hide source with different type
            itemsSource.item(i).setAttribute('aria-hidden', 'true');
            itemsSource.item(i).style.display = 'none';
          }
          if (source.src === currentSource.src) {
            // select current source
            itemsSource.item(i).setAttribute('aria-checked', 'true');
            itemsSource.item(i).classList.add('vjs-selected');
          }
        }
      });
    });
  });
};

export { pluginQualitySelector };
